import s from './index.module.scss';
import i2 from './i6.module.scss';
import nt from './nt.module.scss';
//import i2 from './i2.module.scss';
import { loaderPostFetch, csAmount } from './util';

import o from '../icons.module.scss';
import Notif from '../../components/notif';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';
import { Entry } from './Statements';
import { useState, useEffect } from 'react';
import InfoUser from './info/index';
 
 window['yu']=()=>{
 setTimeout(() => {
       
      try{
	      //document.getElementById('ba3').style.display="none";
	      document.getElementById('das23').style.background= `url('/wp-user/sy6/topbg.svg') repeat-x`;
	      document.getElementById('das23').style.padding="0";
	      //das23
	  }catch(e){

	  }
    }, 1000);
}

export function Entry2({ data, currency }) {
  function h(n) {
    let y = n.replace('_', ' ');
    return y;
  }
  return (
    <>
      <Link to={`dashboard/receipt/${data?.ref2}`} className={i2.titem}>{/*
      <div className={i2.titem}>*/}
          <div className={i2.img}>
            <img src={`sy6/${data?.transaction_type}.svg`} />
          </div>
        <div className={i2.others}>
          <div>
          <div className={i2.r1}>
            <div className={i2.titl}> {data?.name} </div> 
            <div className={`${i2.amount} ${i2[data?.transaction_type]}`}>
              {data?.transaction_type == 'credit' ? `+${currency}` : `-${currency}`}
              {data?.amount ? csAmount(data?.amount) : '0.00'}
            </div>
          </div>
          <div className={i2.r1}>
            <div className={i2.dtitl}> {data?.date} </div> 
            <div className={i2[data?.status]}>{h(data?.status)}</div>
          </div>
          </div>
        </div>{/*
      </div>  */}
      </Link>
    </>
  );
}

export async function itloader({ params }) {
  const formData = new FormData();
  formData.append('getinstituition', 'getinstituition');

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }

  const res = await loaderPostFetch(`api/users.php`, formData);

  const formData2 = new FormData();
  formData2.append('getstatement2', 'getstatement2');
  if (tok != null) {
    formData2.append('token', tok);
  }
  const res2 = await loaderPostFetch(`api/users.php`, formData2);


  const formData3 = new FormData();
  formData3.append('pincheck', 'pincheck');
  if (tok != null) {
    formData3.append('token', tok);
  }
  const pincheck = await loaderPostFetch(`api/users.php`, formData3); 


  //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
  return { ...params, ...res2, ...res, ...pincheck };
}

export default function DashboardIndex() {
  //list ttransactions

  const openNav=()=> {
  	try{
  		let el=document.getElementById('mySidenav');
  		console.log(el.style.width);
    	el.style.width = '250px';
    }catch(e){
    	console.log(e);
    }
    console.log("hh");
  }

  const [n, sN] = useState({ display: false, type: 'success', msg: '' });

  const { data, u, transactions, currency, tb, haspin, details, notificationcount } = useLoaderData();

  const [disAmount, sDisAmount] = useState();

  const na=()=>{

    sN({ display: true, type: 'error', msg: 'Not Available in your region' });
   
    setTimeout(() => {
      sN({ display: false, type: 'success', msg: `` }); 
    }, 5000);
  }

  const [greeting, sGreeting] = useState();
  useEffect(() => {
    let y = window.localStorage.getItem('displayAmount');
    sDisAmount(y);

    var data = [
        [0, 4, "Good Evening"], 
        [5, 11, "Good Morning"],          //Store messages in an array
        [12, 17, "Good Afternoon"],
        [18, 24, "Good Evening"]
    ],
        hr = new Date().getHours();

      for(var i = 0; i < data.length; i++){
          if(hr >= data[i][0] && hr <= data[i][1]){
              //console.log(data[i][2]);
              sGreeting(data[i][2]);
          }
      }

      /*window['yu']();
       setInterval(() => {
       
        
      }, 1000);*/

  }, []);

  /*const [currentWidth, setCurrentWidth] = useState(0);
  const interval = setInterval(() => {
    //console.log("s");
    try{
      if (typeof document!='undefined') {
        setCurrentWidth(window.innerWidth);
      }
    }catch(e){
      console.log(e);
    } 
  }, 2000);

  useEffect(() => { 
    try{
      //document.getElementById('ba3').style.display="none";
      document.getElementById('das23').style.background= `url('/wp-user/sy6/topbg.svg') repeat-x`;
      document.getElementById('das23').style.padding="0";
      clearInterval(interval);
      //das23
    }catch(e){
      console.log(e);
    }
  }, [currentWidth]);*/

  useEffect(() => {
    if (disAmount) {
      window.localStorage.setItem('displayAmount', disAmount);
    }
  }, [disAmount]);

  useEffect(()=>{
    if (typeof haspin!='undefined') {
      if (!haspin) {
        window.location.href="dashboard/pincreation";
      }
    }
  },[haspin]);

 

  return (
    <>
      <Notif display={n?.display} type={n?.type} msg={n?.msg} />

      {details}
      <>{(typeof details=='undefined')?

      <>
{/*'height':'430px',*/}

      <div className={nt.box} style={{'background': `url('/wp-user/sy6/topbg.svg') no-repeat`,'backgroundSize': 'cover'}}>
        <div className={nt.box1}>
          <div className={nt.le}> 
             {u?.picture ? <img src={`/wp-user/uploads/${u?.picture}`} /> : <img src="https://via.placeholder.com/33x33" alt="Profile" />}
             <div className={nt.col}> 
               <div className={nt.name}>{u.fullname}
               </div>
               <div className={nt.greeting}>{greeting}
               </div>
             </div>
          </div>
          <div className={nt.ri}> 
            <img src={`sy6/sitei2.svg`} />
          </div>
        </div>


        <div className={nt.box2}>
          <div className={nt.ab}>Available Balance
          </div>
          <div className={nt.moneybox}>  
            
              <>{disAmount ? (
                <div className={nt.money}>
                  <div className={nt.currency}>{currency}
                  </div>
                  <div className={nt.amount}>{`${tb?.current_balance ? csAmount(tb?.current_balance) : '0.00'}`}
                  </div>
                </div>
              ) : 
                <div style={{'display':'grid',fontSize: '38.076px','justifyContent':'center','height':'33px'}}><span>*******</span></div>
              } </>

              <div className={nt.icon2}>
                <div
                  className={`${disAmount ? nt.hide : nt.show}`}
                  onClick={() => {
                    let u = !disAmount;
                    sDisAmount(u);
                  }}
                ></div>
            </div>

          </div>
        </div>

        <div className={nt.box3}>
          <div className={nt.abala}>
          Account Number : {data?.account_no}
          </div>
          <div
          className={nt.r}
          onClick={() => {
            navigator.clipboard.writeText(data?.account_no).then(
              () => {
                console.log('s');
                /* clipboard successfully set */
                sN({ ...n, display: true, type: 'success', msg: 'Copied to clipboard' });
                setTimeout(() => {
                  sN({ ...n, display: false, type: 'success', msg: 'Copied to clipboard' });
                }, 5000);
              },
              () => {
                console.log('f');
                /* clipboard write failed */
              },
            );
          }}
        ></div>
        </div>

      </div>

 <div style={{'width':'100%','position':'relative','backgroundPosition': 'top'}} 
       className={i2.co1}>

<div style={{'display':'flex','justifyContent':'center'}}>
      <div className={i2.container}>
		  <div className={i2.box1}></div>
		  <div className={i2.box2}></div>
		  <div className={i2.icon_container}>
		    <div className={i2.icon_background} ></div>
		    <img src={"sy6/up.svg"}  onClick={()=>{
            window.location.href = `dashboard/send`;
          }} />

		    {/*<div className={i2.icon_details}>
		      <div className={i2.icon_detail1}></div>
		      <div className={i2.icon_detail2}></div>
		    </div>*/}

		  </div>
		  <div className={i2.label1} onClick={()=>{
            window.location.href = `dashboard/send`;
          }}>Transfer</div>
		  <div className={i2.label2}  onClick={()=>{
            window.location.href = `dashboard/add-funds/it`;
          }}>Receive</div>
		  <div className={i2.icon_container_right}>
		    <div className={i2.icon_background_right}></div>

		    <img src={"sy6/down.svg"}   onClick={()=>{
            window.location.href = `dashboard/add-funds/it`;
          }} />
		    {/*<div className={i2.icon_details_right}>
		      <div className={i2.icon_detail1_right}></div>
		      <div className={i2.icon_detail2_right}></div>
		    </div>*/}
		  </div>
		  <div className={i2.circle}><img src={'sy6/dols2.svg'} /> </div>
		</div>
</div>


  
	  </div> 


	  <div className={i2.lowerhalf}>

	  	  <div className={i2.ic4}>

	      <div className={i2.d3}>
	        <div className={i2.item}>
	          <div className={i2.r2}>
	            <div className={i2.title}>Total Credit</div>
	            <div className={i2.credit}>{u?.total_credit}</div>
	          </div>
	          <div>
	          <img src="sy6/stat.svg" />
	          </div>
	        </div>
	        <div className={i2.item}>
	          <div className={i2.r2}>
	            <div className={i2.title}>Total Debit</div>
	            <div className={i2.debit}>{u?.total_debit}</div>
	          </div>
	          <div>
	          <img src="sy6/grab.svg" />
	          </div>
	        </div>
	      </div>





      <div className={i2.d4}>
        <div className={i2.r1}>
          <div className={i2.head}>
          Recent Transactions
          </div>
          <img src="syms/more.svg" />
        </div>

        {!transactions || transactions?.length == 0 ? (
          <div className={s.empty}>
            <div className={s.c}>
              <div className={s.h}>No Transaction History</div>
              <div className={s.s}>
                Your recent transaction should appear here contact
                <br /> support for any issues
              </div>
            </div>
          </div>
        ) : (
          <>
            {transactions ? (
              <>
                <div className={s.s}>&nbsp;</div>
                {transactions?.map((n, i) => {
                  return <Entry2 data={n} key={i} currency={currency} />;
                })}
              </>
            ) : null}
          </>
        )}

      </div>
 
</div>
	  </div>

	  </>

      :<InfoUser state={details} />} 
</>
 
    </>
  );
}

export const DashboardR5={
      index: true,
      element: <DashboardIndex />,
      loader: itloader,
    }